import React, { useState } from 'react';
import { TopBar } from './components/TopBar';
import { KpiRow } from './components/KpiRow';
import { ActivityTimeline } from './components/ActivityTimeline';
import { PageAnalysis } from './components/PageAnalysis';
import { FollowUpPanel } from './components/FollowUpPanel';
import { InsightsSection } from './components/InsightsSection';
import { BottomSection } from './components/BottomSection';
import { HeatmapModal } from './components/HeatmapModal';
export function App() {
  const [showHeatmap, setShowHeatmap] = useState(false);
  const [dateRange, setDateRange] = useState('7 dage');
  const [device, setDevice] = useState('Alle');
  const [scenario, setScenario] = useState('Alle');
  const [priceDisplay, setPriceDisplay] = useState('Med moms');
  const openHeatmap = () => setShowHeatmap(true);
  const closeHeatmap = () => setShowHeatmap(false);
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-0">
      <TopBar dateRange={dateRange} setDateRange={setDateRange} device={device} setDevice={setDevice} scenario={scenario} setScenario={setScenario} priceDisplay={priceDisplay} setPriceDisplay={setPriceDisplay} data-id="element-1" />
      <main className="container mx-auto px-4 py-6 max-w-7xl" data-id="element-2">
        <div className="flex flex-col lg:flex-row gap-6" data-id="element-3">
          <div className="flex-1" data-id="element-4">
            <KpiRow data-id="element-5" />
            <ActivityTimeline openHeatmap={openHeatmap} data-id="element-6" />
            <PageAnalysis openHeatmap={openHeatmap} data-id="element-7" />
            <InsightsSection data-id="element-8" />
            <BottomSection data-id="element-9" />
          </div>
          <div className="w-full lg:w-80 xl:w-96" data-id="element-10">
            <FollowUpPanel data-id="element-11" />
          </div>
        </div>
      </main>
      {showHeatmap && <HeatmapModal onClose={closeHeatmap} data-id="element-12" />}
    </div>;
}